import { CountryRegionData } from 'react-country-region-selector'

type CountryRegionEntry = readonly [countryName: string, countryCode: string, regions: string]

function getCountryRegionDataset() {
  return CountryRegionData.default as readonly CountryRegionEntry[]
}

export function getCountryOptions(): readonly string[] {
  return [...getCountryRegionDataset()]
    .map(([countryName]) => countryName)
    .sort((left, right) => left.localeCompare(right))
}

export function getRegionOptions(country: string): readonly string[] {
  if (!country) {
    return []
  }

  const selectedCountry = getCountryRegionDataset().find(
    ([countryName]) => countryName === country,
  )

  if (!selectedCountry?.[2]) {
    return []
  }

  return selectedCountry[2]
    .split('|')
    .map((regionPair) => regionPair.split('~')[0])
    .sort((left, right) => left.localeCompare(right))
}
